import { render, staticRenderFns } from "./DashboardUsersMain.vue?vue&type=template&id=004d921a&"
import script from "./DashboardUsersMain.vue?vue&type=script&lang=js&"
export * from "./DashboardUsersMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports